import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export interface BrowserContextCommandProperties extends CommandProperties {}

export type BrowserContextCommandResult = {
	browserUrl: string;
	htmlBody?: string;
	canvasText?: string;
	selection?: {
		content: string;
	};
};

/**
 * A command sent by Rovo Chat to request browser context from the browser extension.
 *
 * This command allows Rovo Chat to collect contextual information about the user's
 * current browsing session at prompt time to provide timely browser context.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId}
 * to return the current browser context data.
 */
export const BrowserContextCommand: CommandConstructor<
	BrowserContextCommandProperties,
	BrowserContextCommandResult
> = createCommand<BrowserContextCommandProperties, BrowserContextCommandResult>(
	'browser-context-command',
);
